import React, {FC} from "react"
import {WellnessMedia} from "@irati/types"
import AudioPlayer from "../AudioPlayer"
import PremiumPlaceholder from "./PremiumPlaceholder"

interface Props {
  media: WellnessMedia,
  isMediaRented: boolean
}

const PremiumAudioPlayer: FC<Props> = ({media, isMediaRented}) => (
  isMediaRented ?
    <AudioPlayer media={media} /> :
    <PremiumPlaceholder media={media} />
)


export default PremiumAudioPlayer
